import { OrgModalLocale } from "../index";

const locale: OrgModalLocale = {
  name: 'name',
  code: 'code',
  domain: 'domain',
  owner: 'administrative account',
  desc: 'description',
};

export default locale
